<template>
  <div class="d-flex flex-column ga-3">
    <div v-for="link in links" :key="link.key" class="ai-suggestion-row">
      <div class="text-body-2">
        <span class="text-medium-emphasis">"{{ link.phrase }}"</span>
        <v-icon size="small" class="mx-1">mdi-arrow-right</v-icon>
        <v-chip
          size="small"
          :color="link.linked ? 'primary' : undefined"
          variant="tonal"
        >
          {{ link.type === "Contact" ? "#" : "@" }}{{ link.label }}
        </v-chip>
      </div>
      <div v-if="link.reason" class="text-caption text-medium-emphasis">
        {{ link.reason }}
      </div>

      <div v-if="link.linked" class="text-caption mt-1">
        <v-icon size="small" color="primary">mdi-check</v-icon> Gekoppeld
      </div>
      <div
        v-else-if="!link.available"
        class="text-caption text-medium-emphasis mt-1"
      >
        Deze woorden staan niet meer in de tekst.
      </div>
      <div v-else class="d-flex ga-2 mt-2 ai-suggestion-actions">
        <v-btn
          color="primary"
          variant="flat"
          class="flex-grow-1"
          prepend-icon="mdi-link-variant"
          @click="$emit('accept', link)"
        >
          Koppelen
        </v-btn>
        <v-btn variant="text" @click="$emit('reject', link)">Afwijzen</v-btn>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * The mentions section of the AI-check: names typed as plain text that can be turned
 * into a mention of a colleague (@) or a contact (#). Accepting replaces the words
 * in the editor; it can be undone there.
 */
defineProps({
  // [{ key, phrase, type: "User"|"Contact", id, label, reason, linked, available }]
  links: { type: Array, default: () => [] },
});

defineEmits(["accept", "reject"]);
</script>
